export const declensionWithNumber = (
  number: number,
  forms: [string, string, string],
): string => {
  const absNumber = Math.abs(number) % 100
  const lastDigit = absNumber % 10

  let form: string

  if (absNumber > 10 && absNumber < 20) {
    form = forms[2] // Родительный падеж множественного числа
  } else if (lastDigit === 1) {
    form = forms[0] // Именительный падеж единственного числа
  } else if (lastDigit >= 2 && lastDigit <= 4) {
    form = forms[1] // Родительный падеж единственного числа
  } else {
    form = forms[2] // Родительный падеж множественного числа
  }

  return `${number} ${form}`
}
